import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBox, faLaptop,
    faMobilePhone,
    faTv
} from "@fortawesome/free-solid-svg-icons";
import {HashLink} from "react-router-hash-link";

function Download({data}) {
    return (
        <>
            <section className="py-10 md:py-20 text-center container">
                <h3
                    className=" uppercase text-[21px] md:text-4xl leading-[1.3em] font-semibold">
                    <HashLink to="/descarga/#inicio" className="no-underline">Descargar STELLA TV APK</HashLink>
                </h3>
                <h5 className="mt-5 uppercase text-lg leading-[21px] font-semibold ">
                    <HashLink   to="/descarga/#inicio" className="no-underline text-white">Descargar Stella TV</HashLink>
                </h5>
                <div className="mt-7 grid md:grid-cols-2 gap-5 max-md:px-4">
                    <div className="md:pl-[30%]">
                        <div className="relative grid grid-cols-2 gap-[3px]">
                            <a href={data.android_url}
                               className="flex items-center justify-center gap-2 py-3 px-2 bg-[#D6A509] text-[15px] text-white font-bold hover:bg-[#FF5A19] transition rounded-s-[40px]"
                               download="">
                                <FontAwesomeIcon
                                    icon={faMobilePhone}
                                    className="w-6 h-6 text-white cursor-pointer"
                                /> CELULAR
                            </a>
                            <a href={data.tv_url}
                               className="flex items-center justify-center gap-2 py-3 px-2 bg-[#D6A509] text-[15px] text-white font-bold hover:bg-[#FF5A19] transition rounded-e-[40px]"
                               download="">
                                <FontAwesomeIcon
                                    icon={faTv}
                                    className="w-6 h-6 text-white cursor-pointer"
                                /> SMART TV</a></div>
                    </div>
                    <div className="md:pr-[30%]">
                        <div className="relative grid text-white grid-cols-2 gap-[3px]">
                            <a href={data.tv_url}
                               className="flex items-center justify-center gap-2 py-3 px-2 bg-[#D6A509] text-[15px] font-bold hover:bg-[#FF5A19] transition rounded-s-[40px]"
                               download="">
                                <FontAwesomeIcon
                                    icon={faBox}
                                    className="w-6 h-6"
                                />
                            TV BOX/FIRE TV</a>
                            <a href={data.tv_url}
                               className="flex items-center justify-center gap-2 py-3 px-2 bg-[#D6A509] text-[15px] font-bold hover:bg-[#FF5A19] transition rounded-e-[40px]"
                               download="">
                                <FontAwesomeIcon
                                    icon={faLaptop}
                                    className="w-6 h-6"
                                />
                                PC/MAC</a></div>
                    </div>
                </div>
            </section>
        </>
    );
}


export default Download